import { getDefaultState } from "./moduleRequestTypeConfigState";

export default {
	SET_REQUEST_TYPE: (state, requestType) => {
		state.requestType = requestType;
	},

	ADD_REQUEST_TYPE_FIELD(state, { payload, stepId }) {
		// parent step
		if (stepId === state.requestType.id) {
			state.requestType = {
				...state.requestType,
				controls: [...state.requestType.controls, payload]
			};
		} else {
			// child steps
			const index = state.requestType.statuses.findIndex(
				t => t.id === stepId
			);
			if (index !== -1) {
				Object.assign(state.requestType.statuses[index], {
					...state.requestType.statuses[index],
					controls: [
						...state.requestType.statuses[index].controls,
						payload
					]
				});
			}
		}
	},

	UPDATE_REQUEST_TYPE_FIELD(state, { payload, stepId }) {
		// parent step
		if (stepId === state.requestType.id) {
			const indexField = state.requestType.controls.findIndex(
				t => t.id === payload.id
			);
			if (indexField !== -1) {
				Object.assign(state.requestType.controls[indexField], payload);
			}
		} else {
			// child steps
			const index = state.requestType.statuses.findIndex(
				t => t.id === stepId
			);
			const indexField = state.requestType.statuses[index].controls.findIndex(
				t => t.id === payload.id
			);
			if (index !== -1 && indexField !== -1) {
				Object.assign(state.requestType.statuses[index].controls[indexField], payload);
			}
		}
	},

	DELETE_REQUEST_TYPE_FIELD(state, { id, stepId }) {
		// parent step
		if (stepId === state.requestType.id) {
			state.requestType = {
				...state.requestType,
				controls: state.requestType.controls.filter(field => field.id !== id)
			};
		} else {
			// child steps
			const index = state.requestType.statuses.findIndex(
				t => t.id === stepId
			);
			if (index !== -1) {
				Object.assign(state.requestType.statuses[index].controls, state.requestType.statuses[index].controls.filter(field => field.id !== id));
			}
		}
	},

	SORT_REQUEST_TYPE_FIELD(state, { payload, stepId }) {
		// parent step
		if (stepId === state.requestType.id) {
			state.requestType = {
				...state.requestType,
				controls: [...payload]
			};
		} else {
			// child steps
			const index = state.requestType.statuses.findIndex(
				t => t.id === stepId
			);
			if (index !== -1) {
				Object.assign(state.requestType.statuses[index], {
					...state.requestType.statuses[index],
					controls: [...payload]
				});
			}
		}
	},

	ADD_REQUEST_TYPE_STEP(state, newStep) {
		// child steps
		state.requestType = {
			...state.requestType,
			statuses: [...state.requestType.statuses, newStep]
		};
	},

	UPDATE_REQUEST_TYPE_STEP(state, stepData) {
		// child steps
		const index = state.requestType.statuses.findIndex(
			t => t.id === stepData.id
		);
		if (index !== -1) {
			Object.assign(state.requestType.statuses[index], stepData);
		}
	},

	DELETE_REQUEST_TYPE_STEP(state, stepId) {
		// child steps
		const index = state.requestType.statuses.findIndex(
			t => t.id === stepId
		);
		if (index !== -1) {
			state.requestType = {
				...state.requestType,
				statuses: state.requestType.statuses.filter(step => step.id !== stepId)
			};
		}
	},

	SET_GENERAL_DATA(state, payload) {
		state.generalData = JSON.parse(payload);
		state.isLoadedGeneralData = true;
	},

	ADD_REQUEST_TYPE_STATISTICAL_EXPRESSION(state, statisticalExpressionData) {
		state.requestType = {
			...state.requestType,
			statistic_expressions: [...state.requestType.statistic_expressions, statisticalExpressionData]
		};
	},

	UPDATE_REQUEST_TYPE_STATISTICAL_EXPRESSION(state, statisticalExpressionData) {
		const index = state.requestType.statistic_expressions.findIndex(
			t => t.id === statisticalExpressionData.id
		);
		if (index !== -1) {
			Object.assign(state.requestType.statistic_expressions[index], statisticalExpressionData);
		}
	},

	DELETE_REQUEST_TYPE_STATISTICAL_EXPRESSION(state, statisticalExpressionId) {
		// child steps
		const index = state.requestType.statistic_expressions.findIndex(
			t => t.id === statisticalExpressionId
		);
		if (index !== -1) {
			state.requestType = {
				...state.requestType,
				statistic_expressions: state.requestType.statistic_expressions.filter(statisticalExpression => statisticalExpression.id !== statisticalExpressionId)
			};
		}
	},

	RESET_STATE(state) {
		Object.assign(state, getDefaultState());
	}
};
